import { SET_NOTIFICATIONS, DELETE_NOTIFICATION, UPDATE_NOTIFICATION, REMOVE_NOTIFICATION } from './actions'
import NOT_CON from '../notificationConstants'

const mutations = {
  [SET_NOTIFICATIONS] (state, { notifications, user }) {
    // TODO need to optimize this....
    let userNotifications = []
    let targetNotifications = []
    for (let n of notifications) {
      if (n.user_id && n.user_id.toString().toLowerCase() === user.toLowerCase()) {
        userNotifications.push(n)
      } else if (n.notification_type === NOT_CON.TYPE_AUDIENCE_MATTERS.toLowerCase()) {
        targetNotifications.push(n)
      }
    }
    state.notifications.allUserNotifications = userNotifications
    state.notifications.allTargetNotifications = targetNotifications
    createNotification(state.notifications)
  },
  [DELETE_NOTIFICATION] (state, notification) {
    let nots = state.notifications
    nots.allUserNotifications = nots.allUserNotifications.filter(n => n.id !== notification.id)
  },
  [UPDATE_NOTIFICATION] (state, notification) {
    const idx = state.notifications.findIndex(n => n.id === notification.id)
    if (idx === -1) state.notifications.push(notification)
    else state.notifications[idx] = notification
  },
  [REMOVE_NOTIFICATION] (state, notificationsToDelete) {
    let removeFromUsers = []
    let removeFromTargets = {}
    for (let n of notificationsToDelete) {
      if (n.user_id) {
        removeFromUsers.push(n.id)
      } else if (n.target_id) {
        removeFromTargets[n.id] = n
      } else {
        // NOT sure what to do with this notification
      }
    }
    state.notifications.allUserNotifications = filterIdsToRemove(removeFromUsers, state.notifications.allUserNotifications)
    state.notifications.allTargetNotifications = filterIdsToRemove(Object.keys(removeFromTargets), state.notifications.allTargetNotifications)
    createUserNotifications(state.notifications)
    let targetNotifications = state.notifications.targets
    if (targetNotifications) {
      for (let n of Object.values(removeFromTargets)) {
        targetNotifications[n.target_id] = targetNotifications[n.target_id].filter(tn => tn.id !== n.id)
      }
    } else {
      createTargetNotifications(state.notifications)
    }
  },
}

const filterIdsToRemove = function (idsToRemove, listToRemoveFrom) {
  let setOfObjects = {}
  for (let n of listToRemoveFrom) {
    setOfObjects[n.id] = n
  }
  for (let id of idsToRemove) {
    delete setOfObjects[id]
  }
  return Object.values(setOfObjects)
}

const createUserNotifications = function (notifications) {
  notifications.openAP = notifications.allUserNotifications.filter(n => n.notification_type === NOT_CON.TYPE_OPEN_AP.toLowerCase())
}

const createTargetNotifications = function (notifications) {
  let targetDict = {}
  for (let n of notifications.allTargetNotifications) {
    let targetList = targetDict[n.target_id]
    if (!targetList) {
      targetList = []
      targetDict[n.target_id] = targetList
    }
    targetList.push(n)
  }
  for (let list of Object.values(targetDict)) {
    list.sort((n1, n2) => {
      return n1.id - n2.id
    })
  }
  notifications.targets = targetDict
}

const createNotification = function (notifications) {
  createUserNotifications(notifications)
  createTargetNotifications(notifications)
}

export default mutations



// WEBPACK FOOTER //
// ./src/app/appLogic/notifications/store/mutations.js